import { Home, Camera, Calendar } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export function BottomNav() {
  const location = useLocation();

  // List of paths where the BottomNav should NOT be displayed
  const excludedPaths = ['/cart', '/checkout', '/404']; // Add paths you want to exclude

  // Check if the current path is excluded
  const isExcluded = excludedPaths.includes(location.pathname);

  // Return null if the current path is excluded
  if (isExcluded) {
    return null;
  }

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="z-50 fixed bottom-0 left-0 right-0 bg-white border-t lg:hidden">
      <nav className="flex justify-around items-center h-16">
        <a
          href="/"
          className={`flex flex-col items-center gap-1 ${
            isActive("/") ? "text-[#B87775]" : ""
          }`}
        >
          <Home className="h-5 w-5" />
          <span className="text-xs font-medium">HOME</span>
        </a>
        <a
          href="/booking"
          className={`flex flex-col items-center gap-1 ${
            isActive("/booking") ? "text-[#B87775]" : ""
          }`}
        >
          <Calendar className="h-5 w-5" />
          <span className="text-xs font-medium">BOOK</span>
        </a>
        <a
          href="/gallery"
          className={`flex flex-col items-center gap-1 ${
            isActive("/gallery") ? "text-[#B87775]" : ""
          }`}
        >
          <Camera className="h-5 w-5" />
          <span className="text-xs font-medium">GALLERY</span>
        </a>
      </nav>
    </div>
  );
}
